import React from 'react';

import {SchemaTag} from 'folder-items/FileConstants';
import {tryParse} from 'notebook/data-tables/DatetimeFields';
import DatetimeField from 'ui-library/inputs/DatetimeField';
import {DatetimePickerRef} from 'ui-library/inputs/InputConstants';
import {ElementKeyboardEvent} from 'util/Types';

interface DatetimeValueEditorProps {
  autoFocus: boolean;
  defaultValue?: SchemaTag;
  onChange: (value: object) => void;
  onKeyDown?: (e: ElementKeyboardEvent) => void;
  placeholder?: string;
  datePickerPopperContainerSelector?: string;
  wrapperClassName?: string;
  datetimePickerRef?: DatetimePickerRef;
  isDisabled?: boolean;
}

export default function DatetimeValueEditor({
  autoFocus,
  datePickerPopperContainerSelector,
  datetimePickerRef,
  defaultValue,
  isDisabled,
  onChange,
  onKeyDown,
  placeholder = 'YYYY-MM-DD hh:mm:ss AM/PM',
  wrapperClassName,
}: DatetimeValueEditorProps): JSX.Element {
  const handleChange = (datetimeTextValue: string): void => {
    onChange({
      datetimeValue: tryParse(datetimeTextValue),
      value: datetimeTextValue,
    });
  };

  return (
    <DatetimeField
      dataTestAttrs={{component: 'DatetimeValueEditor', element: 'root'}}
      autoFocus={autoFocus}
      labelStyle={DatetimeField.LABEL_STYLES.HIDDEN}
      placeholder={placeholder}
      onChange={handleChange}
      onKeyDown={onKeyDown}
      value={defaultValue ? defaultValue.value : null}
      datePickerPopperContainerSelector={datePickerPopperContainerSelector}
      wrapperClassName={wrapperClassName}
      datetimePickerRef={datetimePickerRef}
      isDisabled={isDisabled}
    />
  );
}
